import { render } from "./vplusset.vue?vue&type=template&id=1528c89c&scoped=true"
import script from "./vplusset.vue?vue&type=script&lang=js"
export * from "./vplusset.vue?vue&type=script&lang=js"

import "./vplusset.vue?vue&type=style&index=0&id=1528c89c&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境租户后台rent.syinba.com/jsvueweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1528c89c"]])

export default __exports__